// extracted by mini-css-extract-plugin
module.exports = {"panel":"index_panel__2ZFUt","placeholder":"index_placeholder__27HvM"};